export const metersToKilometers = (mtrs: number = 0) => {
  const km = mtrs / 1000;
  const kmFixed = km.toFixed(1);
  return kmFixed;
};
